<template>
	<div class="page flex-column">
		<div class="head flex-center">
			<div v-if="lastDate" class="date">最近更新：{{lastDate}}</div>
			<p>生产车间数据中心</p>
			<div class="exit flex-center" @click="exitHandle"><i class="tf">&#xe620;</i>退出大屏</div>
		</div>
		<m-col class="body">
			<m-row style="flex-grow: 550;">
				<m-col style="flex-grow: 550;">
					<module :title="task_title" chart>
						<biax ref="task"></biax>
					</module>
					<module :title="product_title" chart>
						<bar ref="product"></bar>
					</module>
				</m-col>
				<m-col style="flex-grow: 700;">
					<quota :period="getPeriod(7)" style="flex-grow: 380;"></quota>
					<module style="flex-grow: 136;">
						<notice ref="noticeList" @update="updateNoticeList">
							<template #process_name="{data}">
								{{data.product_code}} | {{data.process_name}}
							</template>

							<template #fine_count="{data}">
								良品数：<span style="color: #fff;">{{data.fine_count}}</span>
							</template>

							<template #defects_count="{data}">
								不良品数：<span style="color: #FF2A2A;">{{data.defects_count}}</span>
							</template>
						</notice>
					</module>
				</m-col>
				<m-col style="flex-grow: 550;">
					<module :title="fine_title" chart>
						<bar ref="fine"></bar>
					</module>
					<module :title="defects_title" chart>
						<pie ref="defects"></pie>
					</module>
				</m-col>
			</m-row>
			<m-row style="flex-grow: 400;">
				<module :title="workList_title">
					<list ref="workList">
						<template #work_state="{data}">
							<c-state dict="orderStateDic" tag :value="data.work_state"></c-state>
						</template>
				
						<template #process_rate="{data}">
							<div style="width: 100%;" :style="{'height': `${70 * processRateScale}px`}">
								<process-rate :key="data._timestamp" :id="data.work_id" :detail="false" style="transform-origin: left top;" :style="{'width': `${1 / processRateScale * 100}%`, 'transform': `scale(${processRateScale})`}"></process-rate>
							</div>
						</template>
					</list>
				</module>
				<module :title="taskList_title" :period="false">
					<list ref="taskList">
						<template #defects_count="{data}">
							<span style="color: #FF2A2A;">{{data.defects_count}}</span>
						</template>
					</list>
				</module>
			</m-row>
		</m-col>
	</div>
</template>

<script>
	import module from './components/module'
	import mCol from './components/col'
	import mRow from './components/row'
	import quota from './module/quota'
	import notice from './module/notice'
	import biax from './module/biax'
	import bar from './module/bar'
	import pie from './module/pie'
	import list from './module/list'
	import {SYS} from '@/config'
	import {createStore, mapStore, throttle} from '@deanwu/vue-component-library'

	export default {
		components: {
			module,
			mCol,
			mRow,
			quota,
			notice,
			biax,
			bar,
			pie,
			list
		},

		data() {
			return {
				digitalStore: createStore({
					px(n) {
						if (window.innerWidth >= 1400) {
							return n;
						} else {
							return n * Math.min(1, 0.000714796 * window.innerWidth);
						}
					},
					registerChart: obj => {
						this.charts.push(obj);
					}
				}),
				charts: [],
				lastDate: '',
				processRateScale: 1,
				task_title:'每日任务与报工',
				product_title:'每日任务与报工',
				fine_title:'报工良品数',
				defects_title:'不良品项分布',
				workList_title:'生产工单执行分析',
				taskList_title:'任务执行分析',
			}
		},

		computed: {
			...mapStore('digitalStore', ['px'])
		},
		
		mounted() {
			this.fullHandle();
			this.update();
			this.processRateScale = Math.min(1, this.px(62) / 62);
			window.addEventListener('resize', throttle(() => {
				this.charts.forEach(item => {
					item.resize();
				});
				this.processRateScale = Math.min(1, this.px(62) / 62);
			}, 500));
		},
		
		beforeDestroy() {
			clearTimeout(this._timer);
		},

		methods: {
			fullHandle() {
				if (SYS == 'digital') return;
				const elem = document.documentElement;
				if (elem.requestFullscreen) {
					elem.requestFullscreen();
				} else if (elem.mozRequestFullScreen) {
					elem.mozRequestFullScreen();
				} else if (elem.webkitRequestFullscreen) {
					elem.webkitRequestFullscreen();
				} else if (elem.msRequestFullscreen) {
					elem.msRequestFullscreen();
				}
			},

			exitHandle() {
				if (SYS == 'digital') {
					this.logout();
					return;
				}
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.mozCancelFullScreen) {
					document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				} else if (document.msExitFullscreen) {
					document.msExitFullscreen();
				}
				this.navigateTo('/');
			},

			getPeriod(day) {
				let now = new Date();
				return {
					start_date: new Date(now.getFullYear(), now.getMonth(), now.getDate() - day + 1).format('yyyy-MM-dd'),
					end_date: now.format('yyyy-MM-dd'),
				}
			},

			update() {
				this.updateNoticeList();
				this.updateTaskChart();
				this.updateProductChart();
				this.updateFineChart();
				this.updateDefectsChart();
				this.updateWorkList();
				this.updateTaskList();
				this.lastDate = new Date().format('yyyy/MM/dd hh:mm');

				this._timer = setTimeout(this.update, 120000);
			},

			updateNoticeList() {
				this.$refs.noticeList.init({
					fieldList: [{
						code: 'output_user_name',
						width: 100
					}, {
						code: 'process_name',
						width: 260
					}, {
						code: 'fine_count',
						width: 140
					}, {
						code: 'defects_count',
						width: 140
					}, {
						code: 'output_date',
						width: 160
					}]
				});

				this.request({
					url: '/digital/output/notice',
					data: {},
					success: data => {
						this.$refs.noticeList.update(data.list);
					}
				})
			},

			updateTaskChart() {
				this.request({
					url: '/digital/output/chart',
					data: this.getPeriod(7),
					success: data => {
						this.task_title = data.title;
						this.$refs.task.update({
							left_name: '报工',
							right_name: '任务',
							list: data.list.map(item => {
								return {
									name: item.date_time,
									left_value: item.output_count,
									right_value: item.plan_count
								}
							})
						})
					}
				})
			},

			updateProductChart() {
				this.request({
					url: '/digital/production/chart',
					data: this.getPeriod(7),
					success: data => {
						this.product_title = data.title;
						this.$refs.product.update({
							list: data.list.map(item => {
								return {
									name: item.product_name,
									value: item.completed_count
								}
							})
						})
					}
				})
			},

			updateFineChart() {
				this.request({
					url: '/digital/output/list',
					data: this.getPeriod(7),
					success: data => {
						this.fine_title = data.title;
						this.$refs.fine.update({
							list: data.list.map(item => {
								return {
									name: item.output_user_name,
									value: item.fine_count
								}
							})
						})
					}
				})
			},

			updateDefectsChart() {
				this.request({
					url: '/digital/defects/dist',
					data: this.getPeriod(7),
					success: data => {
						this.defects_title = data.title;
						this.$refs.defects.update({
							list: data.list.map(item => {
								return {
									name: item.defects_name,
									value: item.count
								}
							})
						})
					}
				})
			},

			updateWorkList() {
				this.$refs.workList.init({
					fieldList: [{
						code: 'work_code',
						name: '工单编号',
						width: 160
					}, {
						code: 'work_state',
						name: '状态',
						width: 80
					}, {
						code: 'product_name',
						name: '产品名称',
						width: 120
					}, {
						code: 'process_rate',
						name: '生产进度',
						width: 280
					}, {
						code: 'plan_count',
						name: '计划数',
						width: 80
					}, {
						code: 'completed_count',
						name: '已生产数',
						width: 80
					}]
				});

				this.request({
					url: '/digital/work/list',
					data: Object.assign(this.getPeriod(7), {
						pageIndex: 1,
						pageSize: 10
					}),
					success: data => {
						this.workList_title = data.title;
						let now = new Date().getTime();
						data.list.forEach(item => {
							item._timestamp = now;
						});
						this.$refs.workList.update(data.list);
					}
				})
			},

			updateTaskList() {
				this.$refs.taskList.init({
					fieldList: [{
						code: 'process_name',
						name: '工序名称',
						width: 170
					}, {
						code: 'task_count',
						name: '任务数',
						width: 130
					}, {
						code: 'plan_count',
						name: '计划数',
						width: 130
					}, {
						code: 'fine_count',
						name: '良品数',
						width: 130
					}, {
						code: 'defects_count',
						name: '不良品数',
						width: 130
					}, {
						code: 'unfinish_count',
						name: '未完成数',
						width: 130
					}]
				});

				this.request({
					url: '/digital/task/list',
					data: Object.assign(this.getPeriod(7), {
						pageIndex: 1,
						pageSize: 10
					}),
					success: data => {
						this.taskList_title = data.title;
						this.$refs.taskList.update(data.list);
					}
				})
			},
			
			logout() {
				this.request({
					url: '/sys_user/logout',
					loading: true,
					success: () => {
						this.$store.commit('setSession', '');
						this.navigateTo('/login');
					}
				});
			}
		}
	}
</script>

<style lang="stylus">
	html {
		font-size: 100px;

		@media screen and (max-width: 1399px) {
			font-size: 7.14796vw;
		}
	}
</style>

<style lang="stylus" scoped>
	.page {
		box-sizing: border-box;
		height: 100vh;
		overflow: hidden;
		background-color: #011131;
		background-image: url('~@/assets/image/digital/bg.jpg');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
		user-select: none;

		.head {
			position: relative;
			height: .72rem;
			margin-bottom: .22rem;
			background-image: url('~@/assets/image/digital/head.png');
			background-size: auto 100%;
			background-position: center;
			
			&:after {
				content: '';
				position: absolute;
				left: 0;
				top: 0;
				width: .5rem;
				height: .02rem;
				background-image: url('~@/assets/image/digital/an_head.png');
				background-size: 100%;
				animation: headMove 5s infinite linear;
			
				@keyframes headMove {
					0% {
						opacity: 0;
						transform: translate(0,0);
					}
					10% {
						opacity: 1;
					}
					70% {
						opacity: 1;
					}
					80% {
						opacity: 0;
						transform: translate(100vw,0);
					}
					100% {
						opacity: 0;
						transform: translate(100vw,0);
					}
				}
			}

			.date {
				position: absolute;
				top: .14rem;
				left: .95rem;
				font-size: .16rem;
				color: #01F5C3;
			}

			p {
				padding-bottom: .05rem;
				font-size: .32rem;
				font-weight: bold;
				color: transparent;
				background: linear-gradient(to bottom, #FFFFFF, #75DAFF);
				background-clip: text;
			}

			.exit {
				position: absolute;
				top: -.03rem;
				right: .9rem;
				width: 1.2rem;
				height: .44rem;
				font-size: .14rem;
				color: #00F6C2;
				background-image: url('~@/assets/image/digital/exit.png');
				background-size: 100% 100%;
				cursor: pointer;

				.tf {
					margin-right: .08rem;
				}
			}
		}

		.body {
			padding: 0 .3rem .2rem;
		}
		
		.echart {
			height: 100%;
		}
	}

	>>> .process-rate {
		.circle {
			color: #fff !important;
			background: none !important;
		}

		p {
			white-space: nowrap;
			color: #fff !important;
		}

		.__bar-is-horizontal {
			background: rgba(255,255,255,.2) !important;
		}
	}

	>>> .c-progress-circle-text {
		span {
			color: #fff !important;
		}
	}

	>>> .c-empty {
		&-icon {
			width: .8rem;
			height: .8rem;
		}

		&-message {
			margin-top: .1rem;
			font-size: .16rem;
		}
	}
</style>
